import { CalendarIcon, FileIcon, MessagesSquareIcon } from "lucide-react";

import { IconData } from "../ui/icon";
import { SIDEBAR_ICONS } from "./SidebarIcons.constants";

export type SidebarIconName = keyof typeof SIDEBAR_ICONS;

export const SIDEBAR_ICON_NAMES = Object.keys(
  SIDEBAR_ICONS,
) as SidebarIconName[];

export function isSidebarIconName(name: string): name is SidebarIconName {
  return name in SIDEBAR_ICONS;
}

export function getSidebarIcon(name?: string | null): IconData | undefined {
  if (!name || !isSidebarIconName(name)) return undefined;
  return SIDEBAR_ICONS[name];
}

export function defaultSidebarIcon(type?: string): IconData {
  if (type === "discussion") return MessagesSquareIcon;
  if (type === "calendar") return CalendarIcon;
  return FileIcon;
}
